/**
 * RegionalSalesSubregions — "By Sub-region" card: revenue + venue /
 * ticket counts per sub-region. Port of the V3Sales sub-region module.
 *
 * Behind <MockedOverlay> until the DTO ships `subregions` (BON-138).
 * Sub-region names are region-specific data, so the skeleton renders
 * three unnamed cards rather than borrowing the design's PNW fixtures.
 */
import { MockedOverlay } from '../primitives';

const EM_DASH = '—';

const SKELETON_KEYS = ['first', 'second', 'third'] as const;

function SubregionCard() {
  return (
    <div
      style={{
        padding: '10px 12px',
        background: 'var(--nb-surface)',
        borderRadius: 8,
        border: '1px solid var(--nb-border)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--nb-subtle)' }}>
          {EM_DASH}
        </span>
        <span
          className="nb-tabular nb-mono"
          style={{ fontSize: 13, fontWeight: 700, color: 'var(--nb-ink)' }}
        >
          {EM_DASH}
        </span>
      </div>
      <div style={{ fontSize: 10.5, color: 'var(--nb-subtle)', marginTop: 2 }}>
        {EM_DASH} venues · {EM_DASH} tickets
      </div>
    </div>
  );
}

export function RegionalSalesSubregions() {
  return (
    <section className="nb-card">
      <div className="nb-card-hd">
        <h3 className="nb-display" style={{ fontSize: 13, letterSpacing: '0.04em', margin: 0 }}>
          By Sub-region
        </h3>
        <span className="nb-eyebrow">this week</span>
      </div>
      <MockedOverlay reason="Sub-region revenue rollup isn't on the sales DTO yet. Tracked in BON-138.">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {SKELETON_KEYS.map((k) => (
            <SubregionCard key={k} />
          ))}
        </div>
      </MockedOverlay>
    </section>
  );
}
